import React, { type FC, useEffect, useRef } from 'react';
import { FocusPanelFrame } from '../../frames';
import { connectWixelEditorPanel } from './wixelEditorPanel.mapper';

export interface WixelEditorPanelOwnProps {
  panelName: string;
  url: string;
}

export interface WixelEditorPanelDispatchProps {
  closePanel: () => void;
  selectComponentByExternalId: (externalId: string) => void;
}

interface WixelEditorPanelProps
  extends WixelEditorPanelOwnProps,
    WixelEditorPanelDispatchProps {}

export const WixelEditorPanel: FC<WixelEditorPanelProps> = ({
  panelName,
  url,
  closePanel,
  selectComponentByExternalId,
}) => {
  const closePanelRef = useRef(closePanel);
  const selectComponentByExternalIdRef = useRef(selectComponentByExternalId);
  closePanelRef.current = closePanel;
  selectComponentByExternalIdRef.current = selectComponentByExternalId;

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (
        !event.origin.includes('wixel') &&
        !event.origin.includes('wix.com')
      ) {
        return;
      }

      const { type, externalId } = event.data || {};

      if (type === 'WIXEL_SELECT_ID' && externalId) {
        selectComponentByExternalIdRef.current(externalId);
        closePanelRef.current();
      }
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  return (
    <FocusPanelFrame
      panelName={panelName}
      isSingleInstance={true}
      shouldHideHelp={true}
      shouldNotCloseOnBlur={true}
      className="wixel-editor-panel"
      automationId="wixel-editor-panel"
    >
      <iframe
        src={url}
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
      />
    </FocusPanelFrame>
  );
};

export default connectWixelEditorPanel(WixelEditorPanel);
